// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Modal Variant Tokens
 *
 * Each modal wrapper (MapCombatPanel, BossMapModal, DiamondMapModal) sets
 * \`data-modal-variant="<variant>"\` on its body container. Descendant question
 * cards, segmented progress, answer chips, etc. read these tokens to theme
 * themselves consistently with the modal's identity.
 *
 * Tokens:
 *   --modal-accent       primary highlight (borders, fills, emphasis)
 *   --modal-accent-soft  low-alpha accent (backgrounds, hover states)
 *   --modal-accent-glow  glow color for box-shadow on active/complete
 *   --modal-accent-ink   text color on a filled accent background
 *
 * When no variant is set, fallback colors in individual component CSS apply
 * (via \`var(--modal-accent, <fallback>)\`). This keeps un-themed modals from
 * regressing while the primitive is rolled out variant-by-variant.
 */

[data-modal-variant="resuscitate"] {
  --modal-accent: #ffffff;
  --modal-accent-soft: rgba(255, 255, 255, 0.14);
  --modal-accent-glow: rgba(255, 255, 255, 0.28);
  --modal-accent-ink: #0a0a0a;
}

[data-modal-variant="boss"] {
  --modal-accent: #ef4444;
  --modal-accent-soft: rgba(239, 68, 68, 0.16);
  --modal-accent-glow: rgba(239, 68, 68, 0.32);
  --modal-accent-ink: #ffffff;
}

[data-modal-variant="diamond"] {
  --modal-accent: #a78bfa;
  --modal-accent-soft: rgba(167, 139, 250, 0.16);
  --modal-accent-glow: rgba(167, 139, 250, 0.32);
  --modal-accent-ink: #0a0a0a;
}

[data-modal-variant="level"] {
  --modal-accent: #22c55e;
  --modal-accent-soft: rgba(34, 197, 94, 0.16);
  --modal-accent-glow: rgba(34, 197, 94, 0.3);
  --modal-accent-ink: #0a0a0a;
}

/**
 * Unified modal-content centering.
 *
 * Every modal-wrapper body (.mcp-content, .bmm-content) horizontally centers
 * its direct children and caps them to a readable max-width. Question cards,
 * loader shells, and generic session content inherit this automatically —
 * inner components do not set their own alignment.
 *
 * DiamondMapModal (.dmm-content) is intentionally excluded — diamond session
 * layouts have bespoke side-by-side panels that must remain stretched.
 */
.mcp-content,
.bmm-content {
  align-items: center;
}

.mcp-content > *,
.bmm-content > * {
  width: 100%;
  max-width: min(100%, 920px);
  margin-left: auto;
  margin-right: auto;
}

/* Embedded sessions inside MapCombatPanel need to center their own children —
   .mcp-embedded-session is a flex column that wraps Suspense → session. The
   session's internal content card should sit centered, max-width 760px so
   question text doesn't stretch on ultrawide viewports. */
.mcp-embedded-session {
  align-items: center;
  justify-content: center;
  padding: 20px clamp(16px, 4vw, 40px) 32px;
}

.mcp-embedded-session > * {
  width: 100%;
  max-width: min(100%, 760px);
}

.mcp-content .app-loader-shell,
.bmm-content .app-loader-shell {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ─── Resuscitate: ghost-glass modal body ─────────────────────────
   More translucent + blurrier than the default. The near-opaque boss/level
   body is intentional (reads as a solid combat HUD); Resuscitate is a
   between-life liminal space — should feel like you're looking through it. */
.mcp-body[data-modal-variant="resuscitate"] {
  background: rgba(14, 14, 20, 0.58);
  backdrop-filter: blur(28px) saturate(140%);
  -webkit-backdrop-filter: blur(28px) saturate(140%);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow:
    0 12px 48px rgba(0, 0, 0, 0.55),
    inset 0 0 64px rgba(255, 255, 255, 0.03),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.mcp-body[data-modal-variant="resuscitate"] .cbd-bundle-card {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow:
    0 2px 12px rgba(0, 0, 0, 0.25),
    inset 0 0 40px rgba(255, 255, 255, 0.015);
}

/* Ethereal question-card interior — Resuscitate scope only. */
.mcp-body[data-modal-variant="resuscitate"] .cbd-question-atom {
  color: rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 500;
}

.mcp-body[data-modal-variant="resuscitate"] .cbd-question-num {
  color: #ffffff;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.35);
  letter-spacing: 0.14em;
}

.mcp-body[data-modal-variant="resuscitate"] .diamond-q-text {
  color: rgba(255, 255, 255, 0.96);
  font-weight: 400;
  letter-spacing: 0.005em;
  text-shadow: 0 0 14px rgba(255, 255, 255, 0.08);
}

/* Matching-game ghost pills — lift the default bg so they feel weightless
   on the translucent body. */
.mcp-body[data-modal-variant="resuscitate"] .matching-item {
  background: rgba(255, 255, 255, 0.045);
  border-color: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: rgba(255, 255, 255, 0.92);
}

.mcp-body[data-modal-variant="resuscitate"] .matching-item--left:hover,
.mcp-body[data-modal-variant="resuscitate"] .matching-item--right.hover-target,
.mcp-body[data-modal-variant="resuscitate"] .matching-item--left.active-drag {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.38);
  color: #ffffff;
  box-shadow: 0 0 16px rgba(255, 255, 255, 0.18);
}

.mcp-body[data-modal-variant="resuscitate"] .matching-col-label {
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modal-variants.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;;;;;;;;;;EAUE;AACF;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;0DAG0D;AAC1D;EACE,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;6EAG6E;AAC7E;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,2CAA2C;EAC3C;;;2CAGyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,0BAA0B;EAC1B,kCAAkC;EAClC;;6CAE2C;AAC7C;;AAEA,8DAA8D;AAC9D;EACE,gCAAgC;EAChC,qCAAqC;EACrC,0CAA0C;EAC1C,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;6BAC6B;AAC7B;EACE,sCAAsC;EACtC,uCAAuC;EACvC,0BAA0B;EAC1B,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;;;EAGE,oCAAoC;EACpC,uCAAuC;EACvC,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":["/**\n * Modal Variant Tokens\n *\n * Each modal wrapper (MapCombatPanel, BossMapModal, DiamondMapModal) sets\n * `data-modal-variant=\"<variant>\"` on its body container. Descendant question\n * cards, segmented progress, answer chips, etc. read these tokens to theme\n * themselves consistently with the modal's identity.\n *\n * Tokens:\n *   --modal-accent       primary highlight (borders, fills, emphasis)\n *   --modal-accent-soft  low-alpha accent (backgrounds, hover states)\n *   --modal-accent-glow  glow color for box-shadow on active/complete\n *   --modal-accent-ink   text color on a filled accent background\n *\n * When no variant is set, fallback colors in individual component CSS apply\n * (via `var(--modal-accent, <fallback>)`). This keeps un-themed modals from\n * regressing while the primitive is rolled out variant-by-variant.\n */\n\n[data-modal-variant=\"resuscitate\"] {\n  --modal-accent: #ffffff;\n  --modal-accent-soft: rgba(255, 255, 255, 0.14);\n  --modal-accent-glow: rgba(255, 255, 255, 0.28);\n  --modal-accent-ink: #0a0a0a;\n}\n\n[data-modal-variant=\"boss\"] {\n  --modal-accent: #ef4444;\n  --modal-accent-soft: rgba(239, 68, 68, 0.16);\n  --modal-accent-glow: rgba(239, 68, 68, 0.32);\n  --modal-accent-ink: #ffffff;\n}\n\n[data-modal-variant=\"diamond\"] {\n  --modal-accent: #a78bfa;\n  --modal-accent-soft: rgba(167, 139, 250, 0.16);\n  --modal-accent-glow: rgba(167, 139, 250, 0.32);\n  --modal-accent-ink: #0a0a0a;\n}\n\n[data-modal-variant=\"level\"] {\n  --modal-accent: #22c55e;\n  --modal-accent-soft: rgba(34, 197, 94, 0.16);\n  --modal-accent-glow: rgba(34, 197, 94, 0.3);\n  --modal-accent-ink: #0a0a0a;\n}\n\n/**\n * Unified modal-content centering.\n *\n * Every modal-wrapper body (.mcp-content, .bmm-content) horizontally centers\n * its direct children and caps them to a readable max-width. Question cards,\n * loader shells, and generic session content inherit this automatically —\n * inner components do not set their own alignment.\n *\n * DiamondMapModal (.dmm-content) is intentionally excluded — diamond session\n * layouts have bespoke side-by-side panels that must remain stretched.\n */\n.mcp-content,\n.bmm-content {\n  align-items: center;\n}\n\n.mcp-content > *,\n.bmm-content > * {\n  width: 100%;\n  max-width: min(100%, 920px);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Embedded sessions inside MapCombatPanel need to center their own children —\n   .mcp-embedded-session is a flex column that wraps Suspense → session. The\n   session's internal content card should sit centered, max-width 760px so\n   question text doesn't stretch on ultrawide viewports. */\n.mcp-embedded-session {\n  align-items: center;\n  justify-content: center;\n  padding: 20px clamp(16px, 4vw, 40px) 32px;\n}\n\n.mcp-embedded-session > * {\n  width: 100%;\n  max-width: min(100%, 760px);\n}\n\n.mcp-content .app-loader-shell,\n.bmm-content .app-loader-shell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ─── Resuscitate: ghost-glass modal body ─────────────────────────\n   More translucent + blurrier than the default. The near-opaque boss/level\n   body is intentional (reads as a solid combat HUD); Resuscitate is a\n   between-life liminal space — should feel like you're looking through it. */\n.mcp-body[data-modal-variant=\"resuscitate\"] {\n  background: rgba(14, 14, 20, 0.58);\n  backdrop-filter: blur(28px) saturate(140%);\n  -webkit-backdrop-filter: blur(28px) saturate(140%);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  box-shadow:\n    0 12px 48px rgba(0, 0, 0, 0.55),\n    inset 0 0 64px rgba(255, 255, 255, 0.03),\n    inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.mcp-body[data-modal-variant=\"resuscitate\"] .cbd-bundle-card {\n  background: rgba(255, 255, 255, 0.03);\n  border-color: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  box-shadow:\n    0 2px 12px rgba(0, 0, 0, 0.25),\n    inset 0 0 40px rgba(255, 255, 255, 0.015);\n}\n\n/* Ethereal question-card interior — Resuscitate scope only. */\n.mcp-body[data-modal-variant=\"resuscitate\"] .cbd-question-atom {\n  color: rgba(255, 255, 255, 0.55);\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.mcp-body[data-modal-variant=\"resuscitate\"] .cbd-question-num {\n  color: #ffffff;\n  text-shadow: 0 0 8px rgba(255, 255, 255, 0.35);\n  letter-spacing: 0.14em;\n}\n\n.mcp-body[data-modal-variant=\"resuscitate\"] .diamond-q-text {\n  color: rgba(255, 255, 255, 0.96);\n  font-weight: 400;\n  letter-spacing: 0.005em;\n  text-shadow: 0 0 14px rgba(255, 255, 255, 0.08);\n}\n\n/* Matching-game ghost pills — lift the default bg so they feel weightless\n   on the translucent body. */\n.mcp-body[data-modal-variant=\"resuscitate\"] .matching-item {\n  background: rgba(255, 255, 255, 0.045);\n  border-color: rgba(255, 255, 255, 0.12);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.mcp-body[data-modal-variant=\"resuscitate\"] .matching-item--left:hover,\n.mcp-body[data-modal-variant=\"resuscitate\"] .matching-item--right.hover-target,\n.mcp-body[data-modal-variant=\"resuscitate\"] .matching-item--left.active-drag {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.38);\n  color: #ffffff;\n  box-shadow: 0 0 16px rgba(255, 255, 255, 0.18);\n}\n\n.mcp-body[data-modal-variant=\"resuscitate\"] .matching-col-label {\n  color: rgba(255, 255, 255, 0.5);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
